"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinesOfCoverageByPolicyTypeInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var line_of_coverage_types_picker_input_1 = require("../line-of-coverage-types-picker-input");
var policy_type_select_input_1 = require("../policy-type-select-input");
function LinesOfCoverageByPolicyTypeInput(_a) {
    var _b = _a.values, _c = _b === void 0 ? {} : _b, policyType = _c.policyType, _d = _c.selectedOptions, selectedOptions = _d === void 0 ? [] : _d, onChange = _a.onChange, enableAdditions = _a.enableAdditions, disableRepeated = _a.disableRepeated, selectAllLOCsByDefault = _a.selectAllLOCsByDefault, _e = _a.policyTypeFieldId, policyTypeFieldId = _e === void 0 ? 'policyType' : _e, _f = _a.lineOfCoverageTypesFieldId, lineOfCoverageTypesFieldId = _f === void 0 ? 'lineOfCoverageTypes' : _f;
    var handleSelectedOptionsChange = react_1.useCallback(function (value) { return policyType && onChange(policyType, value); }, [policyType, onChange]);
    var handlePolicyTypeChange = react_1.useCallback(function (value) { return onChange(value, selectedOptions); }, [onChange, selectedOptions]);
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
        react_1.default.createElement(core_ui_1.Field, { fieldId: policyTypeFieldId, label: "Policy type" },
            react_1.default.createElement(policy_type_select_input_1.PolicyTypeSelectInput, { value: policyType, onChange: handlePolicyTypeChange })),
        policyType && (react_1.default.createElement(core_ui_1.Field, { fieldId: lineOfCoverageTypesFieldId, label: "Lines of coverage" },
            react_1.default.createElement(line_of_coverage_types_picker_input_1.LineOfCoverageTypesPickerInput, { enableAdditions: enableAdditions, disableRepeated: disableRepeated, selectAllByDefault: selectAllLOCsByDefault, value: selectedOptions, policyType: policyType, onChange: handleSelectedOptionsChange })))));
}
exports.LinesOfCoverageByPolicyTypeInput = LinesOfCoverageByPolicyTypeInput;
